var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6127_16478)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99996 0.666626C8.36815 0.666626 8.66663 0.965103 8.66663 1.33329V9.72382L11.5286 6.86189C11.7889 6.60154 12.211 6.60154 12.4714 6.86189C12.7317 7.12224 12.7317 7.54435 12.4714 7.8047L8.47136 11.8047C8.34634 11.9297 8.17677 12 7.99996 12C7.82315 12 7.65358 11.9297 7.52856 11.8047L3.52855 7.8047C3.26821 7.54435 3.26821 7.12224 3.52855 6.86189C3.7889 6.60154 4.21101 6.60154 4.47136 6.86189L7.33329 9.72382V1.33329C7.33329 0.965103 7.63177 0.666626 7.99996 0.666626ZM0.666626 14.6666C0.666626 14.2984 0.965103 14 1.33329 14H14.6666C15.0348 14 15.3333 14.2984 15.3333 14.6666C15.3333 15.0348 15.0348 15.3333 14.6666 15.3333H1.33329C0.965103 15.3333 0.666626 15.0348 0.666626 14.6666Z",
    fill: "#3A4458"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6127_16478"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadRounded);
export default __webpack_public_path__ + "static/media/downloadRounded.12b7d1eb.svg";
export { ForwardRef as ReactComponent };